import { useContext, useMemo } from "react";
import { NewContext } from "../../../utils/ContextProvider";
import { permisosTecnica } from "./tecnicaPermisos";

const valor = (x) => (typeof x === "function" ? x() : x);

/**
 * Los permisos de Técnica del usuario logueado (tecnicaPermisos.js), leídos del contexto.
 *
 * `listo` espera a isSessionReady y a tecnicaStockCargado: este último se prende en el mismo bloque
 * que isTecnicaAuthorized (ContextProvider), así que también dice «ya volvió /me» para las órdenes.
 * Sin esperar, el menú y la guardia dirían «sin permiso» un instante a quien sí tiene.
 * `aviso` (ERROR_SESION, ERROR_ME, LEGAJO_DUPLICADO) explica un permiso en false que no es «no tenés permiso».
 *
 * @returns {{ listo: boolean, permisos: object, aviso: (string|null) }}
 */
export default function useTecnicaPermisos() {
    const {
        getRol, getModules, isTecnicaAuthorized, tecnicaScope, tecnicaStockNivel,
        tecnicaStockCargado, tecnicaStockAviso, isSessionReady,
    } = useContext(NewContext);

    const rol = valor(getRol);
    const modulos = valor(getModules);

    const permisos = useMemo(
        () => permisosTecnica({ rol, modulos, isTecnicaAuthorized, tecnicaStockNivel, tecnicaScope }),
        [rol, modulos, isTecnicaAuthorized, tecnicaScope, tecnicaStockNivel],
    );
    // Si falló la carga de la sesión (getDateUser), ContextProvider prende tecnicaStockCargado con
    // ERROR_ME aunque isSessionReady quede en false: sin esto la guardia esperaba para siempre.
    const sesionFallida = !isSessionReady && !!tecnicaStockCargado && tecnicaStockAviso === "ERROR_ME";
    const listo = (!!isSessionReady && !!tecnicaStockCargado) || sesionFallida;
    const aviso = sesionFallida ? "ERROR_SESION" : (tecnicaStockAviso || null);

    return useMemo(() => ({ listo, permisos, aviso }), [listo, permisos, aviso]);
}
